<template>
  <div>
    <div class="d-md-block d-none">
      <footer class="FooterAll bg-dark text-light py-2" style="font-size: 16px">
        <div class="row align-items-center justify-content-between">
          <div class="col-md-5">
            <div class="copyright">ⓒ Copyright & web design by 清清小森</div>
          </div>

          <div class="col-md-5 ml-md-0 ml-5">
            <div class="d-flex align-items-center">
              <div class="mr-2">追蹤我們：</div>

              <div class="mr-3">
                <a
                  href="https://shopee.tw/%E3%80%90%E6%B8%85%E6%B8%85%E5%B0%8F%E6%A3%AE-dyson-%E6%B8%85%E4%B8%80%E6%B8%85%E3%80%91%E6%B7%B1%E5%B1%A4%E6%B8%85%E7%90%86%E6%B8%85%E6%BD%94-%E6%88%B4%E6%A3%AE-dyson-%E5%90%B8%E5%A1%B5%E5%99%A8-%E9%9B%BB%E5%8B%95%E5%90%B8%E9%A0%AD-900%E8%B5%B7-%E5%85%A8%E5%8F%B07-11%E6%94%B6%E9%80%81%E4%BB%B6-i.3918719.461535767?sp_atk=f36aa767-3a11-4902-b474-9ab8b9a5e401&xptdk=f36aa767-3a11-4902-b474-9ab8b9a5e401 "
                  target="_blank"
                >
                  <img src="../../assets/images/Shopee2.png" width="30px" alt="" />
                </a>
              </div>
              <div class="mr-3">
                <a href="https://www.facebook.com/cleands717" target="_blank">
                  <img src="../../assets/images/facebook3.png" width="30px" alt="" />
                </a>
              </div>
              <div class="mr-3">
                <a href="https://m.me/cleands717" target="_blank">
                  <img src="../../assets/images/messenger3.png" width="30px" alt="" />
                </a>
              </div>

              <div class="mr-3">
                <a href="https://lin.ee/v0Ta2kq" target="_blank">
                  <img src="../../assets/images/line.png" width="30px" alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
  }
</script>

<style scoped lang="scss">
  .copyright {
    padding: 1rem 0;
  }

  .FooterAll {
    font-size: 50px;
    z-index: 1;
  }
</style>
